'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

var _BoundingBox = require('./BoundingBox');

var _BoundingBox2 = _interopRequireDefault(_BoundingBox);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      position: 'relative'
    },
    trap: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: -1
    },
    trapActive: {
      zIndex: [999, '!important']
    },
    svg: {
      margin: [[0, 'auto']],
      display: 'block',
      maxWidth: '100%',
      height: 'auto',
      background: theme.bgPage
    },
    hidden: {
      visibility: 'hidden'
    },
    darken: {
      background: '#000'
    },
    img: {
      height: 'auto',
      maxHeight: theme.imageMaxHeight,
      maxWidth: '100%'
    }
  };
};

var SvgImage = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(SvgImage, _React$Component);

  function SvgImage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SvgImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SvgImage.__proto__ || Object.getPrototypeOf(SvgImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loaded: false,
      width: 0,
      height: 0,
      image: null
    }, _this.componentDidMount = function () {
      return _this.props.content && _this.setState({
        width: _this.props.content.width || 0,
        height: _this.props.content.height || 0,
        image: _this.props.content.image
      });
    }, _this.componentDidUpdate = function (prev) {
      var content = _this.props.content;

      if (content.image != prev.content.image) {
        _this.setState({
          loaded: false,
          width: content.width,
          height: content.height,
          image: content.image
        });
      }
    }, _this.handleImageLoaded = function (_ref2) {
      var target = _ref2.target;
      var width = _this.state.width || target.width;
      var height = _this.state.height || target.height; // calculate bounding box sizes based on image dimensions

      var _this$props = _this.props,
          minBoxFontSize = _this$props.minBoxFontSize,
          minBoxStrokeWidth = _this$props.minBoxStrokeWidth,
          minWidth = _this$props.minWidth;
      var fontSize = Math.max(minBoxFontSize, minBoxFontSize / minWidth * width);
      var strokeWidth = Math.max(minBoxStrokeWidth, minBoxStrokeWidth / minWidth * width);
      var pixel = Math.max(1, 1 / minWidth * width);

      _this.setState({
        loaded: true,
        width: width,
        height: height,
        strokeWidth: strokeWidth,
        fontSize: fontSize,
        pixel: pixel
      });

      _this.props.onSizeUpdate && _this.props.onSizeUpdate(width, height, strokeWidth, fontSize, pixel);
    }, _this.getSVGPoint = function (x, y) {
      var svgNode = _this.svg;
      if (!svgNode) return _defineProperty({
        y: null
      }, 'y', null);
      var pt = svgNode.createSVGPoint();
      pt.x = x;
      pt.y = y;
      return pt.matrixTransform(svgNode.getScreenCTM().inverse());
    }, _this.handleEvent = function (handler) {
      return function (_ref4) {
        var clientX = _ref4.clientX,
            clientY = _ref4.clientY;
        if (handler) handler(_this.getSVGPoint(clientX, clientY));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SvgImage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          darkenImage = _props.darkenImage,
          previewBoxes = _props.previewBoxes,
          shadeBoxes = _props.shadeBoxes,
          showCenter = _props.showCenter,
          content = _props.content,
          renderSpans = _props.renderSpans,
          trapActive = _props.trapActive,
          children = _props.children,
          style = _props.style,
          classes = _props.classes;
      var _content$spans = content.spans,
          spans = _content$spans === undefined ? [] : _content$spans;
      var _state = this.state,
          width = _state.width,
          height = _state.height,
          loaded = _state.loaded,
          image = _state.image,
          strokeWidth = _state.strokeWidth,
          fontSize = _state.fontSize;
      var viewBox = '0 0 ' + width + ' ' + height;
      var darkenOpacity = 1 - darkenImage; // show image tag if no width/height are defined, so they can be read off the <img> tag

      var needsPreload = !content.width && !content.height || !content.image.startsWith('data:');
      var hidden = !loaded || needsPreload && loaded || !needsPreload;
      var svgClassNames = (0, _classnames2["default"])(classes.svg, _defineProperty({}, classes.darken, darkenOpacity < 1));
      var imgClassNames = (0, _classnames2["default"])(classes.img, _defineProperty({}, classes.hidden, hidden));
      var trapClasses = (0, _classnames2["default"])(classes.trap, _defineProperty({}, classes.trapActive, trapActive));
      return _react2["default"].createElement('div', {
        className: classes.root,
        onMouseMove: this.handleEvent(this.props.handleMouseMove),
        onDoubleClick: this.props.onDoubleClick
      }, _react2["default"].createElement('div', {
        className: trapClasses,
        onMouseDown: this.handleEvent(this.props.handleClick),
        onMouseUp: this.handleEvent(this.props.handleClick)
      }), loaded && _react2["default"].createElement('svg', {
        className: svgClassNames,
        preserveAspectRatio: 'xMinYMin meet',
        viewBox: viewBox,
        width: width,
        height: height,
        ref: function ref(x) {
          _this2.svg = x;
        },
        draggable: false,
        onDragStart: function onDragStart(ev) {
          return ev.preventDefault();
        },
        style: style
      }, _react2["default"].createElement('image', {
        xlinkHref: needsPreload ? loaded && image : image,
        width: width,
        height: height,
        style: {
          opacity: darkenOpacity
        },
        onMouseDown: this.handleEvent(this.props.handleClick),
        onMouseUp: this.handleEvent(this.props.handleClick)
      }), renderSpans && spans.map(function (_ref5, i) {
        var id = _ref5.id,
            points = _ref5.points,
            center = _ref5.center,
            color = _ref5.color,
            label = _ref5.label,
            hidden = _ref5.hidden;
        var isHidden = !previewBoxes && hidden;
        var boxProps = {
          i: i,
          id: id,
          points: points,
          center: center,
          shadeBoxes: shadeBoxes,
          showCenter: showCenter,
          color: color,
          hidden: hidden,
          label: label,
          strokeWidth: strokeWidth,
          fontSize: fontSize
        };
        return !isHidden && _react2["default"].createElement(_BoundingBox2["default"], _extends({
          key: i
        }, boxProps));
      }), children), _react2["default"].createElement('img', {
        className: imgClassNames,
        src: image,
        onLoad: this.handleImageLoaded,
        hidden: hidden
      }));
    }
  }]);

  return SvgImage;
}(_react2["default"].Component), _class2.defaultProps = {
  darkenImage: 0,
  previewBoxes: false,
  shadeBoxes: false,
  showCenter: false,
  minBoxStrokeWidth: 4,
  minBoxFontSize: 16,
  minWidth: 650,
  renderSpans: true
}, _class2.propTypes = {
  darkenImage: _propTypes2["default"].number,
  previewBoxes: _propTypes2["default"].bool,
  shadeBoxes: _propTypes2["default"].bool,
  showCenter: _propTypes2["default"].bool,
  onClick: _propTypes2["default"].func,
  content: _propTypes2["default"].object,
  minBoxStrokeWidth: _propTypes2["default"].number,
  minBoxFontSize: _propTypes2["default"].number,
  renderSpans: _propTypes2["default"].bool,
  onSizeUpdate: _propTypes2["default"].func
}, _temp2)) || _class);
exports["default"] = SvgImage;